<template>
  <v-menu
    v-model="isMenuOpen"
    transition="scale-transition"
    :close-on-content-click="false"
    :nudge-right="40"
  >
    <template #activator="{ props }">
      <v-text-field
        :label="label"
        :model-value="formattedDate"
        readonly
        v-bind="props"
        variant="outlined"
        :density="dense"
        hide-details
        :append-inner-icon="icon"
        :disabled="loading || disabled"
        color="orange lighten-2"
        :rules="rules"
      />
    </template>
    <v-date-picker
      v-model="selectedDate"
      hide-actions
      title=""
      color="primary"
      @update:model-value="isMenuOpen = false"
    >
      <template #header />
    </v-date-picker>
  </v-menu>
</template>

<script lang="ts">
import type DensityProp from '@/types/vuetify/Density'
import { defineComponent, type PropType } from 'vue'

export default defineComponent({
  props: {
    label: {
      type: String,
      default: 'Selecione a Data',
    },
    modelValue: {
      type: [String, Date],
      default: undefined,
    },
    icon: {
      type: String,
      default: 'fa-regular fa-calendar-pen',
    },
    dense: {
      type: String as PropType<DensityProp>,
      default: 'compact',
    },
    disabled: {
      type: Boolean as PropType<boolean>,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Array as PropType<((value: string) => true | string)[]>,
      default: () => [],
    },
  },
  emits: [ 'update:modelValue' ],
  data() {
    return {
      isMenuOpen: false,
      selectedDate: this.modelValue,
    }
  },
  computed: {
    formattedDate() {
      return this.selectedDate
        ? this.formatDate(this.selectedDate)
        : ''
    },
  },
  watch: {
    modelValue(newValue) {
      this.selectedDate = newValue
    },
    selectedDate(newDate) {
      this.$emit('update:modelValue', newDate)
    },
  },
  methods: {
    formatDate(date: Date | string) {
      if (!date) return ''

      if (date instanceof Date) {
        return date.toLocaleDateString('pt-BR', { year: 'numeric', month: '2-digit', day: '2-digit' })
      }

      return date
    },
  },
})
</script>
